import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function JetListAdminStorage({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/jet/administration/storage-profiles/overview'}
                onClick={handleDrawerToggle}
                secondary={'Overview'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/jet/administration/storage-profiles/on-premises'}
                onClick={handleDrawerToggle}
                secondary={'On-Premises Storage'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/jet/administration/storage-profiles/cloud-storage'}
                onClick={handleDrawerToggle}
                secondary={'Cloud Storage'}
            />
        </List>
    );
}

JetListAdminStorage.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default JetListAdminStorage;
